{
  "de": {
    "errors": {
      "audioNotSupported": "Audioformat wird nicht unterstützt",
      "audioRecordingDeviceError": "Audio-Aufnahme-Geräte-Fehler",
      "connectionAuthenticationFailed": "Verbindung wurde von Server abgelehnt. Authentifizierung fehlgeschlagen.",
      "connectionRejected": "Die Verbindung zum Server wurde abgelehnt",
      "createFromTemplateFailed": "Fehler beim Erstellen aus Vorlage",
      "createItemFailed": "Fehler beim Erstellen des Inhalts",
      "deleted": {
        "header": "Dieser Inhalt wurde gelöscht",
        "link": "Zu den fobizz Tools",
        "paragraph": "Die Person, die diesen Inhalt geteilt hat, hat ihn gerade gelöscht. Deshalb kann er nicht mehr angezeigt werden."
      },
      "downloadFailed": "Die Datei konnte nicht heruntergeladen werden. Bitte lade die Seite neu und versuche es erneut.",
      "error": "Fehler",
      "fileAlreadyExists": "Datei '{filename}' existiert bereits",
      "fileUploadFailed": "Fehler beim Hochladen der Datei",
      "forbidden": {
        "header": "Leider hast du keinen Zugriff auf diese Inhalte",
        "link": "Zu den fobizz Tools",
        "paragraph": "Du brauchst eine Einladung per Freigabelink, um diese Inhalte zu sehen. Melde dich bei der Person, die dir den Link geschickt hat und bitte sie, dir den richtigen Link zu schicken."
      },
      "generic": {
        "header": "Da ist etwas schiefgelaufen!",
        "link": "Zu den fobizz Tools",
        "paragraph": "Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal!"
      },
      "h5pContentNotFound": "H5P-Inhalt nicht gefunden",
      "h5pUploadFailed": "Fehler beim Hochladen der H5P-Datei",
      "liveConnectionLost": {
        "description": "Diese Seite wird nicht mehr automatisch aktualisiert. Lade sie neu, um wieder Live-Updates zu erhalten.",
        "reload": "Seite neu laden",
        "title": "Keine Live-Verbindung"
      },
      "toTeachImportFailed": "Fehler beim Importieren der to teach Übung",
      "toTeachNoH5pDownload": "Diese Übung enthält keinen H5P-Download",
      "imageUploadFailed": "Fehler beim Hochladen des Bildes",
      "internalError": "Interner Fehler aufgetreten",
      "invalidUrl": "Dies ist keine korrekte URL.",
      "jobProcessingFailed": "Fehler beim Verarbeiten deiner Anfrage",
      "jobProcessingFailedWithDetails": "Fehler beim Verarbeiten deiner Anfrage: {message}",
      "jobTimeout": "Die Verarbeitung dauert ungewöhnlich lange und wurde abgebrochen. Bitte versuche es erneut.",
      "noAudioInputDeviceFound": "Kein Audio-Input-Gerät gefunden",
      "noVideoInputDeviceFound": "Kein Video-Input-Gerät gefunden",
      "notFound": {
        "header": "Das hat leider nicht geklappt!",
        "link": "Zu den fobizz Tools",
        "paragraph": "Die Adresse, die du suchst, existiert nicht – oder nicht mehr!"
      },
      "partnerNotEnabled": "Leider wurden unsere Partner für dich deaktiviert.",
      "previewImageGenerationFailed": "Die Bildgenerierung ist fehlgeschlagen. Bitte versuche es erneut.",
      "previewImageGenerationTimeout": "Die Bildgenerierung dauert ungewöhnlich lange und wurde abgebrochen. Bitte versuche es erneut.",
      "remixFailed": "Fehler beim Remixen des Inhalts",
      "somethingWentWrong": "Etwas ist schiefgelaufen",
      "unauthorized": {
        "header": "Das hat leider nicht geklappt!",
        "link": "Zu den fobizz Tools",
        "paragraph": "Bitte melde dich an, um auf diese Seite zuzugreifen!"
      },
      "unknownAudioRecordingError": "Unbekannter Audio-Aufnahme-Fehler",
      "unknownErrorRefresh": "Unbekannter Fehler aufgetreten. Seite wird neu geladen!",
      "unknownVideoRecordingError": "Unbekannter Video-Aufnahme-Fehler",
      "uploadFileTooLarge": "Datei kann nicht hochgeladen werden, da sie größer ist als {maxSize} MB",
      "uploadTotalSizeExceeded": "Datei kann nicht hochgeladen werden, da die Gesamtgröße von {maxTotalSize} MB überschritten wird",
      "uploadFileTooSmall": "Datei kann nicht hochgeladen werden, da sie 0 MB groß ist.",
      "validationError": "Fehler bei der Validierung",
      "videoRecordingDeviceError": "Video-Aufnahme-Geräte-Fehler"
    }
  }
}
